export default {
  district(district) {
    return district ? `1${String(district).padStart(2, '0')}0` : ''
  },
  city(district) {
    return district ? 'Wien' : ''
  },
  trim(value) {
    return String(value).trim()
  },
  countStr(count, singular, plural = null) {
    plural = plural || singular
    if (!count) {
      return ''
    }
    if (count === 1) {
      return `${count} ${singular}`
    }
    if (count > 1) {
      return `${count} ${plural}`
    }
  }
}
